<template>
    <el-header class="topbar">
        <picture>
            <source media="(max-width: 600px)" srcset="../assets/WTA_PlayerZone_Mobile.jpg" />
            <source media="(max-width: 1024px)" srcset="../assets/WTA_PlayerZone_Tablet.jpg" />
            <img src="../assets/WTA_PlayerZone_Desktop.jpg" alt="WTA Player Zone Topbar" />
        </picture>
    </el-header>
</template>

<script>
export default {
    data() {
        return {
            mode: process.env.VUE_APP_APPLICATION_MODE,
            currentUrl: this.$route.path,
            homeURL: process.env.VUE_APP_URL_HOME,
        };
    },
    methods: {
        navigate(url) {
            this.$router.push(url);
        },
    },
};
</script>

<style lang="scss">
.topbar {
    height: auto !important;
    padding: 0 !important;
    overflow: hidden;

    img {
        width: 100%;
        height: auto;
        display: block;
    }
}
</style>
